{
  "title": "Campagnes",
  "subtitle": "Une bannière sous la signature, entre deux dates. Fixez les dates et elle apparaît et disparaît toute seule — personne n’a à se souvenir de la retirer.",
  "newCampaign": "Nouvelle campagne",
  "emptyTitle": "Aucune campagne",
  "emptyBody": "Une campagne remplit l’emplacement bannière d’un modèle de signature. Ajoutez d’abord l’emplacement dans le concepteur, sinon la bannière n’a nulle part où apparaître.",
  "liveNow": "En direct",
  "noBanner": "Pas de bannière",
  "statusDraft": "Brouillon",
  "statusScheduled": "Planifiée",
  "statusActive": "Active",
  "statusRunning": "En cours",
  "statusPaused": "En pause",
  "statusEnded": "Terminée",
  "edit": "Modifier",
  "pause": "Mettre en pause",
  "resume": "Reprendre",
  "schedule": "Planifier",
  "startNow": "Démarrer maintenant",
  "end": "Terminer",
  "delete": "Supprimer",
  "deleteConfirm": "Supprimer cette campagne ?",
  "name": "Nom",
  "namePlaceholder": "Roadshow de printemps",
  "starts": "Début",
  "ends": "Fin",
  "banner": "Bannière",
  "chooseBanner": "Choisir une bannière",
  "chooseImage": "Choisir une image",
  "changeImage": "Changer l’image",
  "removeBanner": "Retirer",
  "bannerHint": "Concevez pour 600 px de large — c’est la largeur par défaut de l’emplacement. La hauteur est libre ; environ 100 px est courant. Une campagne sans bannière n’affiche rien, quel que soit son planning.",
  "link": "Lien",
  "linkDescription": "Où mène un clic. Enveloppé dans une redirection de suivi à l’envoi.",
  "linkPlaceholder": "https://exemple.com/offre",
  "linksTo": "Lien vers {{url}}",
  "altText": "Texte alternatif",
  "altTextDescription": "Lu par les lecteurs d’écran, et affiché par les clients qui bloquent les images — la plupart par défaut.",
  "timezoneHint": "Les heures sont dans votre fuseau local. Laissez la fin vide pour une bannière qui tourne jusqu’à ce que quelqu’un l’arrête.",
  "createDraft": "Créer un brouillon",
  "save": "Enregistrer",
  "saveCampaign": "Enregistrer la campagne",
  "createTitle": "Nouvelle campagne",
  "editTitle": "Modifier la campagne",
  "saved": "Campagne enregistrée.",
  "createdDraft": "Créée en brouillon. Planifiez-la ou démarrez-la quand vous êtes prêt.",
  "saveError": "Impossible d’enregistrer cela.",
  "deleted": "{{name}} supprimée.",
  "deleteError": "Impossible de supprimer cette campagne.",
  "statusUpdated": "Campagne {{verb}}.",
  "statusError": "Impossible de modifier cela.",
  "actionsAria": "Actions pour {{name}}",
  "windowNoDates": "Aucune date — elle ne tournera que si elle est démarrée à la main.",
  "windowFromOpen": "À partir du {{starts}}, jusqu’à ce que quelqu’un y mette fin.",
  "windowUntil": "Jusqu’au {{ends}}.",
  "windowRange": "{{starts}} à {{ends}}."
}
